import { Icon, InputField } from "@ospweb/sdk-ui";

import { cn } from "utils";
import { useState } from "react";

interface InputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "onFocus" | "size"
> {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onClear?: () => void;
  onFocus?: (isFocused: boolean) => void;
  autoFocus?: boolean;
  prefixClassName?: string;
  containerClassName?: string;
  inputClassName?: string;
}

export const Input = ({
  value,
  onChange,
  placeholder = "Search",
  onClear,
  onFocus,
  autoFocus = true,
  prefixClassName,
  containerClassName,
  inputClassName,
  ...restProps
}: InputProps) => {
  const [inputValue, setInputValue] = useState<string>(value || "");
  return (
    <InputField
      placeholder={placeholder}
      prefix={
        <Icon
          name="search"
          className={cn("text-content_tertiary", prefixClassName)}
        />
      }
      autoFocus={autoFocus}
      containerClassName={cn(
        "border-content_brand_primary bg-background_solid_tertiary h-40px",
        containerClassName,
      )}
      inputClassName={inputClassName}
      onClear={onClear}
      allowClear={
        inputValue
          ? {
              clearIcon: (
                <div className="flex items-center justify-center w-5 h-5">
                  <Icon
                    name="close-circle"
                    className="text-background_white_overlay20"
                    size={20}
                  />
                </div>
              ),
            }
          : undefined
      }
      value={value}
      onChange={(e) => {
        setInputValue(e.target.value);
        onChange(e.target.value);
      }}
      onFocus={() => {
        onFocus?.(true);
      }}
      onBlur={() => {
        onFocus?.(false);
      }}
      {...restProps}
    />
  );
};
